module.exports = {
      id: "podcast-usage",
      viewBox: "0 0 104.071 88.89",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#podcast",
      toString: function () {
        return this.url;
      }
    }